<template>
  <div class="tile-container">
    <div id="notiz-modal" class="modal fade">
      <div class="modal-dialog modal-lg">
        <div class="modal-content" v-if="shown == true">
          <ValidationObserver v-slot="{ invalid }">
            <div class="modal-header">
              <modal-close-button-new @confirmed="closeModal" />
              <h4 class="modal-title">
                {{ notiz.id ? $t("global.editnote") : $t("global.addnote") }}
              </h4>
            </div>
            <div class="modal-body table-wrapper" style="max-height: 500px">
              <div class="col-xl-6">
                <single-select-person
                  id="notiz-person"
                  :person="notiz.person"
                  :label="$t('global.contactperson') + '*'"
                  :required="true"
                  editable
                  :allowOpen="false"
                  @confirmed="setPerson"
                  :tabindex="1"
                />
              </div>
              <div class="row">
                <div class="col-xl-12">
                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      immediate
                      v-slot="{ passed }"
                    >
                      <input
                        v-model.trim="notiz.bezeichnung"
                        v-bind:class="{ 'border-danger': !passed }"
                        class="form-control"
                      />
                      <label v-bind:class="{ 'text-danger': !passed }">
                        {{ $t("global.designation") }}*
                      </label>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-3">
                  <div class="form-group">
                    <div class="input-group">
                      <input
                        type="date"
                        class="form-control"
                        v-model="datum"
                        @change="checkAktDatum()"
                        :class="pastDate ? 'text-danger' : ''"
                        v-tooltip.hover="
                          pastDate
                            ? (text = $t('global.planneddatebeforetoday'))
                            : (text = '')
                        "
                      />
                    </div>
                    <label>{{ $t("global.date") }}</label>
                  </div>
                </div>
                <div v-if="datum" class="col-xl-3">
                  <div class="form-group">
                    <div class="input-group">
                      <input type="time" class="form-control" v-model="zeit" />
                      <div
                        class="input-group-append text-medium-light h-100 mr-2 d-flex align-items-center"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-clock"
                          class="m-auto"
                        />
                      </div>
                    </div>
                    <label>{{ $t("global.time") }}</label>
                  </div>
                </div>
                <div class="col-xl-3">
                  <div class="form-group">
                    <v-select
                      v-model="notiz.kontaktkategorie"
                      label="bezeichnung"
                      :options="kontaktkategorien"
                      :reduce="(kk) => kk.id"
                      :placeholder="$t('global.contactCategory')"
                    >
                      <span slot="no-options">{{
                        $t("global.taptosearch")
                      }}</span>
                    </v-select>
                    <label> {{ $t("global.contactCategory") }}</label>
                  </div>
                </div>
                <div class="col-xl-3">
                  <div class="form-group">
                    <v-select
                      v-model="notiz.kontaktart"
                      label="bezeichnung"
                      :options="kontaktarten"
                      :reduce="(ka) => ka.id"
                      :placeholder="$t('global.contacttype')"
                    >
                      <span slot="no-options">{{
                        $t("global.taptosearch")
                      }}</span>
                    </v-select>
                    <label> {{ $t("global.contacttype") }}</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-12">
                  <div class="form-group">
                    <ckeditor
                      :editor="editor"
                      v-model="notiz.beschreibung"
                    ></ckeditor>
                    <label>{{ $t("global.description") }}</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-danger"
                :disabled="isBusy"
                @click="oeffneLoeschenModal"
              >
                {{ $t("global.delete") }}
              </button>
              <button type="button" class="btn btn-default" @click="closeModal">
                {{ $t("global.close") }}
              </button>
              <button
                type="button"
                :disabled="invalid || isBusy"
                class="btn btn-primary"
                @click="uebernehmen"
              >
                {{ $t("global.apply") }}
              </button>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
    <loeschen-modal
      id="notiz-loeschen-modal"
      @confirmed="loeschen"
      :multiple="true"
    />
  </div>
</template>
  
  <script>
import ModalCloseButtonNew from "@/components/global/ModalCloseButtonNew";
import SingleSelectPerson from "@/components/global/SingleSelectPerson.vue";
import ClassicEditor from "/custom/custom_ckeditor/build/ckeditor";
import LoeschenModal from "@/components/Modals/LoeschenModal";

import page from "@/mixins/Page";
import { LADE_AUSWAHLWERTE_NOTIZEN } from "@/store/korrespondenz/actions.type";

export default {
  name: "NotizModal",
  components: {
    ModalCloseButtonNew,
    LoeschenModal,
    SingleSelectPerson,
  },
  mixins: [page],
  metaInfo() {},
  props: {
    isBusy: {
      type: Boolean,
      default: false,
    },
    foreignId: {
      type: String,
      reqiured: true,
    },
    firma: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      notiz: {
        person: null,
        kontakt_durch: null,
      },
      datum: null,
      zeit: null,
      verantwortlicher: [{ name: this.$t("global.notlinked") }],
      neueAktivitaet: false,
      shown: false,
      pastDate: false,
      componentKey: 0,
      editor: ClassicEditor,
    };
  },
  computed: {
    kontaktkategorien: {
      get() {
        return this.$store.state.korrespondenz.kontaktkategorien;
      },
    },
    kontaktarten: {
      get() {
        return this.$store.state.korrespondenz.kontaktarten;
      },
    },
  },
  watch: {},
  created() {},
  mounted() {
    if (this.kontaktarten.length == 0)
      this.$store.dispatch(`korrespondenz/${LADE_AUSWAHLWERTE_NOTIZEN}`);

    this.$bus.$on("notiz-modal-show", (data) => {
      if (data.neu) {

        if (this.firma) this.notiz.firmen = [this.firma];
        if (this.foreignId) this.notiz.foreignID = this.foreignId;
        if (data.kontakt_durch) this.notiz.kontakt_durch = data.kontakt_durch;

        if (!data.person) {

          if (this.angemeldeterMitarbeiter) {

            this.notiz.person = this.angemeldeterMitarbeiter.person;
          } else {

            this.notiz.person = [{ name: this.$t("global.notlinked") }];
          }
        } else {

          this.notiz.person = data.person;
        }
        this.datum = new Date().toISOString().split("T")[0];
        this.zeit = new Date().toLocaleTimeString("de-DE", {
          hour: "2-digit",
          minute: "2-digit",
        });
      } else {
        this.notiz = Object.assign({}, data);

        if (this.notiz.datum) {
          let [datePart, timePart] = this.notiz.datum.split(" ");
          this.datum = this.dateFormatZuYMD(datePart);
          this.zeit = timePart || "00:00"; // Falls keine Zeit vorhanden ist, Default setzen
        }
      }

      if (!this.shown) this.openModal();
    });
  },
  methods: {
    // Funktion zum Umwandeln von "YYYY-MM-DD" in "DD.MM.YYYY"
    dateFormatZuDMY(dateStr) {
      if (!dateStr) return null;
      const [year, month, day] = dateStr.split("-");
      return `${day.padStart(2, "0")}.${month.padStart(2, "0")}.${year}`;
    },

    // Funktion zum Umwandeln von "DD.MM.YYYY" in "YYYY-MM-DD"
    dateFormatZuYMD(dateStr) {
      if (!dateStr) return null;
      const [day, month, year] = dateStr.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    setPerson(person) {
      this.notiz.person = person;
    },

    setVerantwortlicher(person) {
      this.verantwortlicher = person;
    },

    openModal() {
      this.shown = true;

      $("#notiz-modal").modal({
        backdrop: "static",
        keyboard: false,
      });
    },

    closeModal() {
      this.shown = false;
      this.notiz = {};
      this.datum = null;
      this.zeit = null;
      $("#notiz-modal").modal("hide");
    },

    loeschen() {
      this.$emit("notizDeleted", this.notiz.id);
      this.geplantdatum = null;
      this.effektivdatum = null;
      this.schliesseLoeschenModal();
      this.closeModal()
    },
    schliesseLoeschenModal() {
      $("#notiz-loeschen-modal").modal("hide");
    },

    oeffneLoeschenModal() {
      $("#notiz-loeschen-modal").modal("show");
    },
    uebernehmen() {
      this.notiz.datum = this.dateFormatZuDMY(this.datum) + " " + this.zeit;
      if (!this.notiz.id) {
        this.$emit("notizCreated", this.notiz);
      } else {
        this.$emit("notizChanged", this.notiz);
      }
      this.closeModal();
    },
    //prüft ob das Geplantdatum vor dem heutigen ist
    checkAktDatum() {
      if (!this.geplantdatum) return (this.pastDate = false);

      const today = new Date().toISOString().slice(0, 10);
      if (this.geplantdatum < today) {
        this.pastDate = true;
      } else {
        this.pastDate = false;
      }
    },
    //prüft ob das Effektivdatum vor dem geplantem ist
    checkGeplantdatum() {
      if (!this.effektivdatum) return (this.pastPlannedDate = false);

      if (this.effektivdatum < this.geplantdatum) {
        this.pastPlannedDate = true;
      } else {
        this.pastPlannedDate = false;
      }
    },
  },
};
</script>
  <style scoped>
/* Scoped Style, da die Paddings der .col-* ansonsten von den Tiles der Startseite ueberschrieben werden */
[class^="col-"],
[class*="col-"] {
  padding-right: 15px !important;
  padding-left: 15px !important;
}
</style>
  